import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { MAPPA_URL } from "../../config";
import { trackMappaClick } from "../../analytics";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className = "" }) => (
  <p
    className={`text-[11px] sm:text-xs font-semibold uppercase tracking-[0.35em] text-gold ${className}`}
  >
    {children}
  </p>
);

export const CtaButton = ({
  children = "RICHIEDI LA TUA MAPPA DEL TEMPIO",
  testId,
  className = "",
  large = false,
}) => (
  <motion.a
    href={MAPPA_URL}
    target="_blank"
    rel="noopener noreferrer"
    onClick={() => trackMappaClick(testId)}
    data-testid={testId}
    whileHover={{ scale: 1.04 }}
    whileTap={{ scale: 0.96 }}
    transition={{ type: "spring", stiffness: 400, damping: 20 }}
    className={`group inline-flex cursor-pointer items-center justify-center gap-3 rounded-full bg-gold font-sans font-semibold uppercase tracking-wide text-black shadow-[0_0_50px_-12px_rgba(255,211,77,0.55)] transition-colors duration-300 hover:bg-gold-bright focus:outline-none focus:ring-2 focus:ring-gold focus:ring-offset-2 focus:ring-offset-ink ${
      large
        ? "px-9 py-4 sm:px-12 sm:py-5 text-sm sm:text-lg"
        : "px-7 py-3.5 text-xs sm:text-sm"
    } ${className}`}
  >
    <span>{children}</span>
    <ArrowUpRight className="h-4 w-4 shrink-0 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
  </motion.a>
);

export const FlagIT = ({ className = "h-3.5 w-5" }) => (
  <svg viewBox="0 0 30 20" className={`inline-block shrink-0 rounded-[2px] ${className}`} aria-label="Bandiera italiana" role="img">
    <rect width="10" height="20" fill="#009246" />
    <rect x="10" width="10" height="20" fill="#FFFFFF" />
    <rect x="20" width="10" height="20" fill="#CE2B37" />
  </svg>
);

export const ChapterNo = ({ children, className = "" }) => (
  <span
    aria-hidden
    className={`font-serif text-6xl sm:text-7xl font-light leading-none text-outline select-none ${className}`}
  >
    {children}
  </span>
);

export const Hairline = ({ className = "" }) => (
  <div aria-hidden className={`gold-hairline w-full ${className}`} />
);
